import { useStore } from 'vuex';
import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';
import { useLoading } from 'vue-loading-overlay';

export interface FiltrosReporte {
    idSucursal: number;
    anio: number;
    mes: number;  // 0 = toda la gestión
    dia: number;  // 0 = todo el mes
}

const useReportes = () => {
    const store = useStore();
    const $loading = useLoading();

    const cabeceras = () => ({
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + store.getters['auth/getToken'],
    });

    const obtenerReporte = async (endpoint: string, filtros: FiltrosReporte) => {
        const respuesta = {
            ok: false,
            datos: {} as Record<string, any[]>,
            extra: { sucursal: '', periodo: '', granularidad: '' },
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(endpoint, {
                headers: cabeceras(),
                params: {
                    id_sucursal: filtros.idSucursal,
                    anio: filtros.anio,
                    mes: filtros.mes,
                    dia: filtros.dia,
                },
            });
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.datos = data.datos;
                respuesta.extra = data.extraData;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje,
                });
            }
        } catch (error: any) {
            loader.hide();
            // Los errores de validación/acceso (400/403) traen un mensaje para el usuario.
            const mensaje = error?.response?.data?.mensaje;
            if (mensaje?.descripcion && error.response.status !== 401) {
                utils.mostrarMensaje({
                    descripcion: mensaje.descripcion,
                    tipoMensaje: mensaje.tipoMensaje || 'warning',
                });
            } else {
                utils.mostrarMensajeErrorApi(error);
            }
        }

        return respuesta;
    };

    const obtenerSucursalesHabilitadas = async () => {
        let sucursales: { id: number, text: string }[] = [];

        try {
            const { data } = await authApi.get('/sucursales/obtener-sucursales-habilitadas', {
                headers: cabeceras(),
            });
            if (data.ok) {
                sucursales = data.datos;
            }
        } catch (error) {
            utils.mostrarMensajeErrorApi(error);
        }

        return sucursales;
    };

    return {
        obtenerReporte,
        obtenerSucursalesHabilitadas,
    };
};

export default useReportes;
